import Vue from 'vue';

import Router from 'vue-router';
Vue.use(Router);

//import Site_ListeJeux from '../pages/site/ListeJeux.vue';
import Site_Awards from '../pages/site/Awards.vue';
import Site_Login from '../pages/site/Login.vue';
import Site_Logout from '../pages/site/Logout.vue';

const checkIfClientAuthenticated = (to, from, next) => {
  var token = localStorage.getItem('discord-token');
  if (token !== null) {
    next();
    return;
  }

  next('/login');
};

const checkIfClientNotAuthenticated = (to, from, next) => {
  var token = localStorage.getItem('discord-token');
  if (token == null) {
    next();
    return;
  }

  next('/awards');
};

const router = new Router({
  routes: [
    {
      path: '/',
      redirect: '/awards'
    },
    {
      path: '/awards',
      name: 'awards',
      component: Site_Awards,
      beforeEnter: checkIfClientAuthenticated
    },
    {
      path: '/login',
      name: 'login',
      component: Site_Login,
      beforeEnter: checkIfClientNotAuthenticated
    },
    {
      path: '/logout',
      name: 'logout',
      component: Site_Logout,
      beforeEnter: checkIfClientNotAuthenticated
    }
  ],
  mode: 'history'
});

export default router;
